import type { ArrowStyle } from './Arrows'
import Arrows from './Arrows'
import type { CarouselItems } from './Carousel'
import Dots from './Dots'

export default function CarouselControls({
  arrows,
  dots,
  dotsVariant = 'default',
  items,
  currentIndex,
  handleNext,
  handlePrev,
  showSlide,
  arrowStyle,
  isShowingVideo = false,
}: {
  arrows: boolean
  dots: boolean
  dotsVariant?: 'default' | 'product-card'
  items: CarouselItems
  currentIndex: number
  handleNext: () => void
  handlePrev: () => void
  showSlide: (index: number) => void
  arrowStyle: ArrowStyle
  isShowingVideo?: boolean
}) {
  return (
    <>
      {arrows && (
        <Arrows
          disableArrows={items.length < 2}
          {...{ handleNext, handlePrev, arrowStyle }}
          aria-label="Controle de navegação: próximo e anterior"
          shouldAlwaysShow={isShowingVideo}
        />
      )}
      {dots && (
        <Dots
          currentIndex={currentIndex}
          items={items}
          handleClick={showSlide}
          variant={dotsVariant}
          aria-label="Controle de navegação: ir para o slide"
        />
      )}
    </>
  )
}
